import DateEnum from 'components/DatePicker/enum';

export const DATE_FORMAT = DateEnum['yyyy/MM/dd'];
export const TIME_FORMAT = DateEnum.HHmm;

export enum ErrMsgEnum {
  required = '請填寫這個欄位。',
  date = '請輸入正確的日期。',
  minDate = '最小日期為 ',
  maxDate = '最大日期為 ',
  time = '請輸入正確的時間。',
  month = '請輸入正確的月份。',
  year = '請輸入正確的年份。',
  multiRquired1 = '請選取 ',
  multiRquired2 = ' 個項目。',
}
